export function initEmbarkSightMapFloorOnMapTab () {
  if (!document.body.classList.contains('ecs_custom_embark')) return

  let sightMapEmbed = null
  let floorRetryInterval = null
  let readyListenerBound = false

  const FLOOR_ID = '154302'
  const MAX_RETRY_ATTEMPTS = 100
  const RETRY_INTERVAL_MS = 300
  const MAP_TAB_SELECTOR = '[data-spaces-tab-control="map"]'

  const applyFloorIfPossible = () => {
    if (!sightMapEmbed || typeof sightMapEmbed.setFloor !== 'function') return false

    try {
      sightMapEmbed.setFloor(FLOOR_ID)
      return true
    } catch (e) {
      return false
    }
  }

  const ensureSightMapEmbed = () => {
    if (sightMapEmbed) return true
    if (typeof SightMap === 'undefined' || typeof SightMap.Embed !== 'function') return false

    const spacesSightMap = document.getElementById('spaces_sightmap')
    if (!spacesSightMap) return false

    sightMapEmbed = new SightMap.Embed('spaces_sightmap')

    if (!readyListenerBound && typeof sightMapEmbed.on === 'function') {
      readyListenerBound = true
      sightMapEmbed.on('ready', () => {
        console.log('SightMap embed ready')
        applyFloorIfPossible()
      })
    }

    return true
  }

  const startFloorRetryLoop = (source) => {
    let attempts = 0
    clearInterval(floorRetryInterval)

    // Tabs can recreate the map/embed; refresh references each map activation.
    sightMapEmbed = null
    readyListenerBound = false

    floorRetryInterval = setInterval(() => {
      attempts += 1

      ensureSightMapEmbed()
      const initialized = applyFloorIfPossible()

      if (initialized) {
        clearInterval(floorRetryInterval)
        console.log(`Floor ${FLOOR_ID} applied (${source})`)
        return
      }

      if (attempts >= MAX_RETRY_ATTEMPTS) {
        clearInterval(floorRetryInterval)
        console.log(`Stopped floor attempts for ${FLOOR_ID} after ${attempts} tries (${source})`)
      }
    }, RETRY_INTERVAL_MS)
  }

  // Use delegated click handling so this survives tab DOM re-renders.
  document.addEventListener('click', (event) => {
    const mapTab = event.target && event.target.closest ? event.target.closest(MAP_TAB_SELECTOR) : null
    if (!mapTab) return
    startFloorRetryLoop('map-tab-click')
  })
}
